import { render, staticRenderFns } from "./BotaoAssinarcomBorda.vue?vue&type=template&id=53d36051&scoped=true"
import script from "./BotaoAssinarcomBorda.vue?vue&type=script&lang=js"
export * from "./BotaoAssinarcomBorda.vue?vue&type=script&lang=js"
import style0 from "./BotaoAssinarcomBorda.vue?vue&type=style&index=0&id=53d36051&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d36051",
  null
  
)

export default component.exports